import { render, staticRenderFns } from "./ModalDeleteContract.vue?vue&type=template&id=32eb4113&scoped=true&"
import script from "./ModalDeleteContract.vue?vue&type=script&lang=ts&"
export * from "./ModalDeleteContract.vue?vue&type=script&lang=ts&"
import style0 from "./ModalDeleteContract.vue?vue&type=style&index=0&id=32eb4113&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32eb4113",
  null
  
)

export default component.exports